module.exports = __webpack_public_path__ + "img/V-63-ST-1200-N.056b56dd.png";